<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" :disabled="$hasExtraModule('equipment') != 'active'" />

        <action-button
          type="delete"
          @click="del(equipment.id)"
          v-if="equipment.id && $can('equipment-access') && modal != true"
          :disabled="$hasExtraModule('equipment') != 'active'"
        />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="equipment.serial_number"
                  v-model="equipment.serial_number"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('equipments.serial_number')"
                  :error-messages="errors.collect('equipment.serial_number')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="equipment.equipment_category_id"
                  v-model="equipment.equipment_category_id"
                  class="required-field"
                  v-validate="'required'"
                  item-text="name"
                  item-value="id"
                  :items="equipmentcategories"
                  :label="$t('equipmentcategories.stitle')"
                  :error-messages="errors.collect('equipment.equipment_category_id')"
                  @change="eqCatOnChange(equipment.equipment_category_id)"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-combobox
                  name="equipment.equipment_type_id"
                  v-model="selectedEquipmentType"
                  class="required-field"
                  v-validate="'required'"
                  item-text="name"
                  item-value="id"
                  :items="equipmenttypes"
                  :label="$t('equipmenttypes.stitle')"
                  :error-messages="errors.collect('equipment.equipment_type_id')"
                  v-on:keyup.enter="equipmentTypeOnEnter"
                  @blur="equipmentTypeOnBlur"
                  clearable
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <span class="subheading">{{ $t("global.no_data_create") }}</span>
                    </v-list-item>
                  </template></v-combobox
                >
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-combobox
                  name="equipment.equipment_manufacturer_id"
                  v-model="selectedEquipmentManufacturer"
                  class="required-field"
                  v-validate="'required'"
                  item-text="name"
                  item-value="id"
                  :items="equipmentmanufacturers"
                  :label="$t('equipmentmanufacturers.stitle')"
                  :error-messages="errors.collect('equipment.equipment_manufacturer_id')"
                  @change="eqManOnChange(selectedEquipmentManufacturer.id)"
                  v-on:keyup.enter="equipmentManufacturerOnEnter"
                  @blur="equipmentManufacturerOnBlur"
                  clearable
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <span class="subheading">{{ $t("global.no_data_create") }}</span>
                    </v-list-item>
                  </template></v-combobox
                >
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-combobox
                  name="equipment.equipment_model_id"
                  v-model="selectedEquipmentModel"
                  class="required-field"
                  v-validate="'required'"
                  item-text="name"
                  item-value="id"
                  :items="equipmentmodels"
                  :label="$t('equipmentmodels.stitle')"
                  :error-messages="errors.collect('equipment.equipment_model_id')"
                  v-on:keyup.enter="equipmentModelOnEnter"
                  @blur="equipmentModelOnBlur"
                  clearable
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <span class="subheading">{{ $t("global.no_data_create") }}</span>
                    </v-list-item>
                  </template></v-combobox
                >
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="equipment.model_details"
                  v-model="equipment.model_details"
                  :label="$t('equipments.model_details')"
                  :error-messages="errors.collect('equipment.model_details')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="equipment.internal_nb"
                  v-model="equipment.internal_nb"
                  :label="$t('equipments.internal_nb')"
                  :error-messages="errors.collect('equipment.internal_nb')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="equipment.year"
                  v-model="equipment.year"
                  :label="$t('equipments.year')"
                  :error-messages="errors.collect('equipment.year')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="equipment.inspection_interval"
                  v-model="equipment.inspection_interval"
                  item-text="text"
                  item-value="key"
                  :items="$dd_inspection_interval()"
                  :label="$t('equipments.inspection_interval')"
                  :error-messages="errors.collect('equipment.inspection_interval')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="next_inspection_date_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="equipment.next_inspection_date"
                      v-model="computedNextInspectionDate"
                      :label="$t('equipments.next_inspection_date')"
                      :error-messages="errors.collect('equipment.next_inspection_date')"
                      append-icon="event"
                      @click:append="next_inspection_date_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      autocomplete="new-password"
                      class="required-field"
                      v-validate="'required'"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="equipment.next_inspection_date"
                    first-day-of-week="1"
                    :locale="this.$locale_bcp47()"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="next_inspection_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="equipment.qr_code"
                  v-model="equipment.qr_code"
                  :label="$t('equipments.qr_code')"
                  :error-messages="errors.collect('equipment.qr_code')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="equipment.swl"
                  v-model="equipment.swl"
                  :label="$t('equipments.swl')"
                  :error-messages="errors.collect('equipment.swl')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="equipment.company_id"
                  v-model="equipment.company_id"
                  item-text="name"
                  item-value="id"
                  :items="companies"
                  :label="$t('equipments.company_id')"
                  :error-messages="errors.collect('equipment.company_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="equipment.responsible_by"
                  v-model="equipment.responsible_by"
                  item-text="fullname"
                  item-value="id"
                  :items="users"
                  :label="$t('equipments.responsible_by')"
                  :error-messages="errors.collect('equipment.responsible_by')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="equipment.notes"
                  v-model="equipment.notes"
                  :label="$t('equipments.notes')"
                  :error-messages="errors.collect('equipment.notes')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2">
          <v-card-text>
            <v-layout>
              <v-flex xs12 md6 class="pa-2">
                <p class="pa-0 ma-0">{{ $t("certificates.documents") }}</p>
                <v-divider class="my-2 py-0"></v-divider>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-file-input
                      v-model="files"
                      color="primary"
                      counter
                      multiple
                      :placeholder="$t('certificates.select_files')"
                      prepend-icon="attach_file"
                      outlined
                      :show-size="1000"
                      accept=".jpg,.jpeg,.png,.pdf"
                      v-validate="'size:5120'"
                      name="file"
                      :error-messages="errors.collect('file')"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip color="primary" dark label small>
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </v-flex>
                  <v-flex xs12>
                    <v-card
                      @drop.prevent="documentOnDrop($event)"
                      @dragover.prevent="document_dragover = true"
                      @dragenter.prevent="document_dragover = true"
                      @dragleave.prevent="document_dragover = false"
                      :class="{ 'grey lighten-2': document_dragover }"
                    >
                      <v-card-text>
                        <v-row class="d-flex flex-column" dense align="center" justify="center">
                          <v-icon :class="[document_dragover ? 'mt-2, mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
                          <p>{{ $t("global.drop_files_here") }}</p>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 class="mt-2 mb-2">
                    <div v-for="(document, index) in equipment.documents" class="mb-2">
                      <action-button type="download" :icon_only="true" small @click="downloadDocument(document)" />
                      <action-button type="delete" :icon_only="true" small @click="deleteDocument(document.id)" />
                      {{ document.original_filename }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 md6 class="pa-2">
                <p class="pa-0 ma-0">{{ $t("equipments.urls") }}</p>
                <v-divider class="my-2 py-0"></v-divider>
                <v-layout row wrap>
                  <v-flex xs12>
                    <!-- list -->
                    <div v-if="equipment.urls">
                      <v-layout row wrap v-for="url in equipment.urls" :key="url.id">
                        <v-text-field :value="url.url" :readonly="true" hide-details autocomplete="new-password">
                          <template v-slot:append>
                            <v-btn small icon target="_blank" @click="redirectUrl(url.url)" color="success">
                              <v-icon>link</v-icon>
                            </v-btn>
                            <v-btn small icon @click="deleteUrl(url.id)" color="error">
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-layout>
                    </div>

                    <!-- control -->
                    <v-layout class="mt-2" row wrap v-for="(url, index) in urls" :key="`url-${index}`">
                      <v-text-field
                        v-model="url.url"
                        label="URL"
                        :prepend-icon="index == urls.length - 1 ? 'fas fa-plus' : ''"
                        @click:prepend="addUrlField"
                        append-outer-icon="fas fa-times"
                        @click:append-outer="removeUrlField(index)"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "EquipmentForm",

  props: ["id", "modal"],

  data() {
    return {
      page_title: "",
      predata: {},
      equipment: {},
      equipmentcategories: [],
      equipmenttypes: [],
      equipmentmanufacturers: [],
      equipmentmodels: [],
      selectedEquipmentType: null,
      selectedEquipmentManufacturer: null,
      selectedEquipmentModel: null,
      companies: [],
      users: [],
      files: [],
      urls: [{ url: "" }],
      document_dragover: false,
      next_inspection_date_menu: false,
      dictionary: {
        attributes: {
          "equipment.serial_number": this.$t("equipments.serial_number"),
          "equipment.equipment_category_id": this.$t("equipmentcategories.stitle"),
          "equipment.equipment_type_id": this.$t("equipmenttypes.stitle"),
          "equipment.equipment_manufacturer_id": this.$t("equipmentmanufacturers.stitle"),
          "equipment.equipment_model_id": this.$t("equipmentmodels.stitle"),
          "equipment.model_details": this.$t("equipments.model_details"),
          "equipment.internal_nb": this.$t("equipments.internal_nb"),
          "equipment.year": this.$t("equipments.year"),
          "equipment.inspection_interval": this.$t("equipments.inspection_interval"),
          "equipment.next_inspection_date": this.$t("equipments.next_inspection_date"),
          "equipment.qr_code": this.$t("equipments.qr_code"),
          "equipment.swl": this.$t("equipments.swl"),
          "equipment.company_id": this.$t("equipments.company_id"),
          "equipment.responsible_by": this.$t("equipments.responsible_by"),
          "equipment.notes": this.$t("equipments.notes")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.$hasExtraModule("equipment") == "active") {
      this.$validator.validateAll().then(() => {
        this.$leaveFormConfirmation(next, this.equipment, this.predata, this.save, this.isFormValid)
      })
    } else {
      next()
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedNextInspectionDate: {
      get() {
        return this.$dateFormatGetter(this.equipment.next_inspection_date)
      },
      set(val) {
        this.$set(this.equipment, "next_inspection_date", this.$dateFormatSetter(val))
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.page_title = this.$t("equipments.new_title")

      let user = this.$store.getters["auth/localUser"]
      this.equipment.responsible_by = user.id || null
      this.predata = JSON.parse(JSON.stringify(this.equipment))

      this.selectedEquipmentType = null
      this.selectedEquipmentManufacturer = null
      this.selectedEquipmentModel = null

      this.ddlists()
    } else {
      axios
        .get(this.API_URL + "equipment/" + this.id)
        .then((res) => {
          this.equipment = res.data.data
          this.predata = JSON.parse(JSON.stringify(this.equipment))

          this.ddlists()

          if (this.equipment.equipment_category_id) {
            this.eqCatOnChange(this.equipment.equipment_category_id)
          }

          if (this.equipment.equipment_manufacturer_id) {
            this.eqManOnChange(this.equipment.equipment_manufacturer_id)
          }

          this.page_title = this.$t("equipments.edit_title", {
            name: this.equipment.serial_number
          })
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    ddlists() {
      let lists = [
        { key: "users", module: "users", query: "show_all=true" },
        { key: "companies", module: "enrolled_organisations", query: "show_all=true" },
        { key: "categories", module: "equipment-categories", query: "show_all=true" },
        { key: "manufacturers", module: "equipment-manufacturers", query: "show_all=true" }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.users = res.data.users
        this.companies = res.data.companies
        this.equipmentcategories = res.data.categories
        this.equipmentmanufacturers = res.data.manufacturers

        if (this.id) {
          this.selectedEquipmentManufacturer = this.equipmentmanufacturers.find((i) => i.id == this.equipment.equipment_manufacturer_id)
        }
      })
    },
    eqCatOnChange(id) {
      if (id) {
        let lists = [{ key: "types", module: "equipment-types", query: "show_all=true&query_equipment_category_id=" + id }]

        axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
          this.equipmenttypes = res.data.types
          this.selectedEquipmentType = null

          if (this.id) {
            this.selectedEquipmentType = this.equipmenttypes.find((i) => i.id == this.equipment.equipment_type_id)
          }
        })
      } else {
        this.equipmenttypes = []
        this.equipment.equipment_type_id = null
        this.selectedEquipmentType = null
      }
    },
    eqManOnChange(id) {
      if (id) {
        let lists = [{ key: "models", module: "equipment-models", query: "show_all=true&query_equipment_manufacturer_id=" + id }]

        axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
          this.equipmentmodels = res.data.models
          this.selectedEquipmentModel = null

          if (this.id) {
            this.selectedEquipmentModel = this.equipmentmodels.find((i) => i.id == this.equipment.equipment_model_id)
          }
        })
      } else {
        this.equipmentmodels = []
        this.equipment.equipment_model_id = null
        this.selectedEquipmentModel = null
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.equipment.id) {
              // Create
              axios
                .post(this.API_URL + "equipment", {
                  serial_number: this.equipment.serial_number,
                  equipment_category_id: this.equipment.equipment_category_id,
                  equipment_type_id: this.selectedEquipmentType.id || null,
                  equipment_manufacturer_id: this.selectedEquipmentManufacturer.id || null,
                  equipment_model_id: this.selectedEquipmentModel.id || null,
                  model_details: this.equipment.model_details,
                  internal_nb: this.equipment.internal_nb,
                  year: this.equipment.year,
                  inspection_interval: this.equipment.inspection_interval,
                  next_inspection_date: this.equipment.next_inspection_date,
                  qr_code: this.equipment.qr_code,
                  swl: this.equipment.swl,
                  company_id: this.equipment.company_id,
                  responsible_by: this.equipment.responsible_by,
                  notes: this.equipment.notes,
                  urls: this.urls,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.equipment = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.equipment))
                      vm.resetUrls()

                      if (vm.files.length > 0) {
                        vm.uploadFiles()
                      }

                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "equipments",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.page_title = this.$t("equipments.edit_title", {
                          name: vm.equipment.serial_number
                        })
                        vm.$router.replace(this.BACKEND_URL + `/equipments/edit/${vm.equipment.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "equipment", {
                  id: this.equipment.id,
                  serial_number: this.equipment.serial_number,
                  equipment_category_id: this.equipment.equipment_category_id,
                  equipment_type_id: this.selectedEquipmentType.id || null,
                  equipment_manufacturer_id: this.selectedEquipmentManufacturer.id || null,
                  equipment_model_id: this.selectedEquipmentModel.id || null,
                  model_details: this.equipment.model_details,
                  internal_nb: this.equipment.internal_nb,
                  year: this.equipment.year,
                  inspection_interval: this.equipment.inspection_interval,
                  next_inspection_date: this.equipment.next_inspection_date,
                  qr_code: this.equipment.qr_code,
                  swl: this.equipment.swl,
                  company_id: this.equipment.company_id,
                  responsible_by: this.equipment.responsible_by,
                  notes: this.equipment.notes,
                  urls: this.urls
                })
                .then((res) => {
                  vm.equipment = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.equipment))
                  vm.resetUrls()

                  if (vm.files.length > 0) {
                    vm.uploadFiles()
                  }

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "equipments",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "equipment/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/equipments")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    documentOnDrop(e) {
      this.document_dragover = false
      if (e.dataTransfer.files.length) {
        Array.from(e.dataTransfer.files).forEach((file) => {
          this.files.push(file)
        })
      }
    },
    uploadFiles() {
      let vm = this
      let formData = new FormData()

      formData.append("id", this.equipment.id)

      this.files.forEach((file, index) => {
        formData.append("files[" + index + "]", file)
      })

      axios
        .post(this.API_URL + "equipment/document/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((res) => {
          vm.equipment = res.data.data
          vm.predata = JSON.parse(JSON.stringify(vm.equipment))
          vm.files = []
        })
        .catch((err) => console.log(err))
    },
    downloadDocument(file) {
      axios({
        url: this.API_URL + "s3/download?file=" + file.filename,
        method: "GET",
        responseType: "arraybuffer"
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", file.original_filename)
            link.click()
          }
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },
    deleteDocument(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .post(this.API_URL + "equipment/document/delete", {
              id: id
            })
            .then((res) => {
              vm.equipment = res.data.data
              vm.predata = JSON.parse(JSON.stringify(vm.equipment))
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((error) => {
              console.log(error.response.data)
            })
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    resetUrls() {
      this.urls = [{ url: "" }]
    },
    addUrlField() {
      this.urls.push({ url: "" })
    },
    removeUrlField(index) {
      if (this.urls.length == 1) return
      this.urls.splice(index, 1)
    },
    redirectUrl(url) {
      window.open(this.$getValidUrl(url), "_blank")
    },
    deleteUrl(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .post(this.API_URL + "equipment/url/delete", {
              id: id
            })
            .then((res) => {
              vm.equipment = res.data.data
              vm.predata = JSON.parse(JSON.stringify(vm.equipment))
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((error) => {
              console.log(error.response.data)
            })
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    // Equipment Type
    equipmentTypeOnBlur(e) {
      let val = this.selectedEquipmentType

      if (typeof val === "string" && val) {
        this.selectedEquipmentType = null
      }
    },
    equipmentTypeOnEnter(e) {
      let val = this.selectedEquipmentType

      if (e.keyCode == 13) {
        if (typeof val === "string" && val) {
          let user = this.$store.getters["auth/user"]
          let obj = {
            name: val,
            equipment_category_id: this.equipment.equipment_category_id,
            status: 1,
            created_by: user.id
          }
          let exist = this.equipmenttypes.find((i) => i.name == val)

          if (!exist) {
            // Add new equipment type
            axios
              .post(this.API_URL + "equipment-type", obj)
              .then((res) => {
                this.equipmenttypes.push(res.data.data)
                this.selectedEquipmentType = res.data.data
                this.$awn.success(this.$t("global.create_success"))
              })
              .catch((error) => {
                this.$handleServerSideError(error)
              })
          } else {
            this.selectedEquipmentType = exist
          }
        }
      }
    },
    // Equipment Manufacturer
    equipmentManufacturerOnBlur(e) {
      let val = this.selectedEquipmentManufacturer

      if (typeof val === "string" && val) {
        this.selectedEquipmentManufacturer = null
      }
    },
    equipmentManufacturerOnEnter(e) {
      let val = this.selectedEquipmentManufacturer

      if (e.keyCode == 13) {
        if (typeof val === "string" && val) {
          let user = this.$store.getters["auth/user"]
          let obj = {
            name: val,
            status: 1,
            created_by: user.id
          }
          let exist = this.equipmentmanufacturers.find((i) => i.name == val)

          if (!exist) {
            // Add new equipment manufacturer
            axios
              .post(this.API_URL + "equipment-manufacturer", obj)
              .then((res) => {
                this.equipmentmanufacturers.push(res.data.data)
                this.selectedEquipmentManufacturer = res.data.data
                this.eqManOnChange(this.selectedEquipmentManufacturer.id)
                this.$awn.success(this.$t("global.create_success"))
              })
              .catch((error) => {
                this.$handleServerSideError(error)
              })
          } else {
            this.selectedEquipmentManufacturer = exist
          }
        }
      }
    },
    // Equipment Model
    equipmentModelOnBlur(e) {
      let val = this.selectedEquipmentModel

      if (typeof val === "string" && val) {
        this.selectedEquipmentModel = null
      }
    },
    equipmentModelOnEnter(e) {
      let val = this.selectedEquipmentModel

      if (e.keyCode == 13) {
        if (typeof val === "string" && val) {
          let user = this.$store.getters["auth/user"]
          let obj = {
            name: val,
            equipment_manufacturer_id: this.selectedEquipmentManufacturer.id || null,
            status: 1,
            created_by: user.id
          }
          let exist = this.equipmentmodels.find((i) => i.name == val)

          if (!exist) {
            // Add new equipment model
            axios
              .post(this.API_URL + "equipment-model", obj)
              .then((res) => {
                this.equipmentmodels.push(res.data.data)
                this.selectedEquipmentModel = res.data.data
                this.$awn.success(this.$t("global.create_success"))
              })
              .catch((error) => {
                this.$handleServerSideError(error)
              })
          } else {
            this.selectedEquipmentModel = exist
          }
        }
      }
    }
  }
}
</script>

<style scoped></style>
